<p-confirmDialog styleClass="w-100" [pt]="{
  host: {
    'aria-label': '確認對話框',
  }
}" />
<p-toast [pt]="{
    root: isLogin() ? 'top-[76px]!' : '',
  }">
  <ng-template let-message #message>
    <span class="p-toast-message-icon p-icon">
      @switch (message.severity) {
      @case ("success") {
      <svg lucideCircleCheck [size]="19.6"></svg>
      }
      @case ("info") {
      <svg lucideInfo [size]="19.6"></svg>
      }
      @case ("error") {
      <svg lucideCircleX [size]="19.6"></svg>
      }
      @case ("warn") {
      <svg lucideTriangleAlert [size]="19.6"></svg>
      }
      @default {
      <svg lucideInfo [size]="19.6"></svg>
      }
      }
    </span>
    <div class="p-toast-message-text">
      @if (message.summary; as summary) {
      <div class="p-toast-summary">
        {{ summary }}
      </div>
      }
      @if (message.detail; as detail) {
      <div class="p-toast-detail">
        {{ detail }}
      </div>
      }
    </div>
  </ng-template>
</p-toast>

<router-outlet />